<template>
    <div>
        <!-- 左按钮 -->
        <button class="switch-btn left-btn" @click="prev" :disabled="mainProjectIndex === 0">
            ←
        </button>
        <!-- 右按钮 -->
        <button class="switch-btn right-btn" @click="next" :disabled="mainProjectIndex === mainProjects.length - 1">
            →
        </button>

        <!-- 血制 -->
        <div class="content" v-if="mainProjectIndex == 0">
            <div class="title">
                <div class="icon"> </div>
                <h1>兰州血液制品生产基地项目</h1>
            </div>
            <!-- <div class="img-container">
                <p class="p-left" style="margin-top: 5em;width:24em;">
                    兰州血液制品生产基地项目以打造“国际领先、国内标杆”的现代化血液制品生产平台为目标，全面融合前沿技术及行业高标准规范。项目总投资13.67亿元，占地面积约173.8亩，致力于建设一座集自动化、信息化与智能化于一体的综合性生产基地，构建了涵盖血液制品生产车间、质检研发车间、高架立体库房、动力中心及污水处理站在内的完整生产链体系。
                </p>
                <img src="../../../../../assets/img/case/yiyao/yiyao_xuezhi.png"></img>
            </div> -->
            <p><img src="../../../../../assets/img/case/yiyao/yiyao_xuezhi.png" class="company-img"></img></p>
            <p>
                在建设过程中，项目集成多项先进系统与设备，包括高架立体库、自动仓储物流系统、全自动分装及包装生产线、分布式控制系统（DCS），以及覆盖厂区的建筑管理系统（BMS）、环境监控系统（EMS）、能源管理系统、制造执行系统（MES）、数据采集与监视控制系统（SCADA）、血浆管理系统和实验室信息管理系统（LIMS）。所有关键生产及质检区域均部署视频监控系统，实现全过程可视化管理。项目依托信息化赋能，实现了从血浆原料验收、制品生产、质量检验到成品出库的全链条数字化管控。
            </p>
            <p>该项目严格遵循国家网络安全三级等保要求，构建独立的工控网络与办公网络体系，全面保障企业数据安全。项目投产后，将显著提升我国血液制品行业的自动化与信息化水平，使生产与检测流程达到国内领先、国际一流标准。</p>
            <p style="text-align: center;"><img src="../../../../../assets/img/case/yiyao/yiyao_xuezhi_1.png"
                    style="width: 100%;margin:2em auto;"></img></p>
        </div>

        <!-- 多糖 -->
        <div class="content" v-if="mainProjectIndex == 1">
            <div class="title">
                <div class="icon"> </div>
                <h1>中国生物兰州生物制品研究所多糖疫苗车间项目</h1>
            </div>
            <!-- <div class="img-container">
                <p class="p-right" style="margin-top: 4.5em;width:18em;margin-right: 4em;">
                    中国生物兰州生物制品研究所多糖疫苗车间项目是兰州生物制品研究所为优化产品布局，着眼长远发展而打造的多产品疫苗生产车间，是兰州生物制品研究所“十四五”期间的重点项目，是目前已知国内单体最大的生物医药厂房，入选2021年甘肃省省列重大项目名单。
                </p>
                <img src="../../../../../assets/img/case/yiyao/yiyao_duotang.png"></img>
            </div> -->
            <p><img src="../../../../../assets/img/case/yiyao/yiyao_duotang.png" class="company-img"></img></p>
            <p>
                项目建成后计划年产13价肺炎球菌结合疫苗2500万剂、四价脑膜炎球菌结合疫苗1000万剂，以及伤寒多糖蛋白结合疫苗3000万剂，将显著提升我国高端疫苗的产业化供应能力和国际竞争力。
            </p>
            <p>本次自控系统建设涵盖空调自控系统、环境监测系统、动力设备自控系统、互锁门控制系统、能源计量系统、自控服务器与工作站、室内综合信息显示系统、数字化集成系统，以及数字化运维平台的深度优化。服务范围包括设备供应与安装、桥架管线敷设、设备接线与测试、系统功能调试、验收交付、符合GAMP5规范的相关验证及长期售后服务。
            </p>
            <p>通过引进锦威工业服务数字化产品，从设备管理、能耗控制和人力成本等方面赋能，全面提升疫苗车间的生产效率与管理水平，从而助推企业实现高质量发展。</p>
        </div>

        <!-- 梅里 -->
        <div class="content" v-if="mainProjectIndex == 2">
            <div class="title">
                <div class="icon"> </div>
                <h1>陕西梅里众诚动物保健有限公司疫苗生产园区项目</h1>
            </div>
            <!-- <div class="img-container">
                <p class="p-left" style="margin-top: 4.5em;width:18em;margin-right: 4em;">
                    陕西梅里众诚动物保健有限公司成立于2016年，位于陕西省西咸新区空港新城，是一家专业从事动物疫苗研发、生产及销售的高科技企业。公司疫苗生产基地占地100亩，一期总投资10.6亿元人民币，总建筑面积43000平方米，是国内第9家农业农村部口蹄疫灭活疫苗定点生产企业。
                </p>
                <img src="../../../../../assets/img/case/yiyao/yiyao_meili.png"></img>
            </div> -->
            <p><img src="../../../../../assets/img/case/yiyao/yiyao_meili.png" class="company-img"></img></p>
            <p>
                该公司是国内首家在兽药生产中全面引入BMS/EMS自动控制系统的企业，BMS/EMS系统的全面应用，能够为企业带来多方面的核心价值，实现了生产全过程自动化。
            </p>
            <p>作为亚洲最大的P3等级实验动物房基地，该系统全面集成了自动化控制与环境监测系统，为核心实验区域持续稳定运行、实现人员、环境与产品之间的可靠隔离提供了技术保障，显著降低了生物安全风险，且项目严格遵循国内及国际最新的BSL3+生物安全实验室标准建设与管理。
            </p>
            <p>本项目在建设及生产期间，成功实现5项科技成果转化，展现出了显著的科技创新能力与突出的经济社会效益。</p>
        </div>

        <foot-img-carousel type="yiyao" :projects="otherProjects" @change="showProjectDetail"></foot-img-carousel>
    </div>
</template>

<script>
import footImgCarousel from './footImgCarousel.vue';
export default {
    components: {
        footImgCarousel
    },
    data() {
        return {
            mainProjectIndex: 0,
            mainProjects: [{
                cover: "xuezhi",
                title: "兰州血液制品生产基地项目",
                hasDetail: true
            },
            {
                cover: "duotang",
                title: "中国生物兰州生物制品研究所多糖疫苗车间项目",
                hasDetail: true
            },
            {
                cover: "meili",
                title: "陕西梅里众诚动物保健有限公司疫苗生产园区项目",
                hasDetail: true
            }],
            otherProjects: [
                {
                    cover: "zhongnongweite",
                    title: "中农威特生物医药基地项目疫苗车间自控弱电施工",
                    // hasDetail: true
                },
                {
                    cover: "shouyansuo",
                    title: "中国农业科学院兰州兽医研究所实验室维修项目",
                    // hasDetail: true
                },
                {
                    cover: "zhongmu",
                    title: "兰州中牧生物药厂生产区整体搬迁项目",
                    // hasDetail: true
                },
                {
                    cover: "xiaofang",
                    title: "兰州生物所消防及工业控制集中监控中心项目",
                    // hasDetail: true
                },
                {
                    cover: "lunzhuang",
                    title: "兰州生物制品研究所轮状病毒车间自控及弱电工程",
                    // hasDetail: true
                },
                {
                    cover: "fankong",
                    title: "兰州兽医研究所2025年高级别生物安全实验室安防改造",
                },
                {
                    cover: "p3",
                    title: "中农威特P3实验室维修改造工程",
                },
                {
                    cover: "gmp",
                    title: "中农威特天津分公司GMP车间改造项目",
                },
                {
                    cover: "60",
                    title: "中农威特60#建筑-生物安全三级防护车间自控与弱电",
                },
                {
                    cover: "jilinguanjie",
                    title: "吉林冠界禽流感灭活疫苗细胞悬浮培养生产线P3改造",
                },
                {
                    cover: "foci",
                    title: "佛慈制药科技工业园自控及弱电工程",
                },
                {
                    cover: "longshenrongfa",
                    title: "甘肃陇神戎发药业自控系统",
                },
                {
                    cover: "fufeng",
                    title: "陕西西岳制药（扶风）有限公司工艺流程自动控制系统",
                },
                {
                    cover: "kanghui",
                    title: "陕西康惠药业公用工程自动化系统",
                },
                {
                    cover: "kunming",
                    title: "中科院昆明动物所ABSL-3生物安全实验室",
                }
            ]

        }
    },
    methods: {
        showProjectDetail(index) {
            this.mainProjectIndex = index
        },
        prev() {
            if (this.mainProjectIndex > 0) this.mainProjectIndex--;
        },
        next() {
            if (this.mainProjectIndex < this.mainProjects.length - 1) this.mainProjectIndex++;
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/case.less';
</style>